module.exports = __webpack_public_path__ + "static/media/sample5.0b769bbd.jpg";